(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const modalOverlay = document.getElementById('modalOverlay-newsletter');
    const closeBtn = document.getElementById('closeBtn-newsletter');
    const submitBtn = document.getElementById('submitBtn-newsletter');
    const emailInput = document.getElementById('emailInput-newsletter');
    const newsletterForm = document.getElementById('newsletterForm');

    const lsKey = 'popupClosed-newsletter-v1';

    //localStorage.removeItem(lsKey); // For testing, remove in production!

    if (!localStorage.getItem(lsKey)) {
      setTimeout(() => { showModal(); }, 1500);
    }

    function showModal() {
      modalOverlay.classList.add('show');
      // Disable scroll on body (JS-only)
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
    }
    function hideModal() {
      modalOverlay.classList.add('closing');
      setTimeout(() => {
        modalOverlay.classList.remove('show', 'closing');
        // Restore scroll on body (JS-only)
        document.body.style.overflow = '';
        document.body.style.height = '';
        localStorage.setItem(lsKey, 'true');
      }, 400);
    }

    closeBtn.addEventListener('click', hideModal);
    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) hideModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modalOverlay.classList.contains('show')) hideModal();
    });

    newsletterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const email = emailInput.value.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email && emailRegex.test(email)) {
        fetch(newsletterForm.action, {
          method: 'POST',
          headers: { 'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8', 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(newsletterForm))
        })
        .then(() => {
          hideModal();
        })
        .catch(() => {
          alert('There was an error. Please try again later.');
        });
      } else {
        alert('Please enter a valid email address.');
        emailInput.focus();
      }
    });

    emailInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') submitBtn.click();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
